/**
 * Class strings shared between MobileOfferCard and its loading skeleton, so the
 * placeholder and the real card cannot drift apart on border, radius or
 * background.
 *
 * They live in their own module rather than being exported from the card: the
 * skeleton is reached through `OfferCardSkeleton`, which is loaded with
 * `dynamic(..., { ssr: false })` precisely to stay light. Importing them from
 * the card would drag its whole graph — Anchor, NextLink, the WhatsApp share
 * button — into that chunk.
 */
export const MOBILE_CARD_CONTAINER_CLASSES =
  'flex h-full select-none flex-col overflow-hidden rounded-3 border-[0.5px] border-neutral-high-200 bg-neutral-high-100 dark:border-0 dark:bg-neutral-low-400';

const DIVIDED_ROW_CLASSES =
  'flex items-center justify-between border-neutral-high-200 px-3 py-2 dark:border-neutral-low-200';

/**
 * The header rule sits below the row and the footer rule above it, so the side
 * is the only difference between the two.
 */
export const mobileCardDividedRow = (side) =>
  `${DIVIDED_ROW_CLASSES} ${side === 'top' ? 'border-t' : 'border-b'}`;
